import Button from 'components/Button'
import { Delivery } from 'components/Icons'
import Percent3 from 'components/Icons/Percent3'
import Input from 'components/Input'
import calculateProductPrice from 'helpers/calculateProductPrice'
import readablePayMethod from 'helpers/readablePayMethod'
import React, { Fragment, useEffect, useState } from 'react'
import { onProductAddToCartEvent } from 'services/conversionevents'
import useCart from 'store/CartProvider'
import useProduct from 'store/SingleProductProvider'
import BorderedSuccess2 from '../../Icons/BorderedSuccess2'
import NoStock from '../../Icons/NoStock'
import Stock from '../../Icons/Stock'
import Slider from '../../Slider'
import { SpecialTag, CardContainer } from '../ProductItem/ProductItem.style'
import {
  DeliveryInfoContainer,
  FooterProductActions,
  ProductActionInputs,
  ProductActions,
  ProductPrice,
  ProductService,
  StorageStatusContainer,
  WarrantyContainer,
} from './MainInfo/MainInfo.style'
import { toast } from 'react-toastify'
import { MobileView } from 'components/DeviceDetect'

import { useHistory } from 'react-router'
import ReactLoaderSpinner from 'react-loader-spinner'

export function ProductRightPane(props) {
  const { product, inStock } = useProduct()
  const isMobile = Boolean(props.mobile)
  const stock_status = product?.stock_status

  const serviceInfo = (
    <ProductService>
      <StorageStatusContainer>
        {inStock ? null : (
          <span className="out-of-stock">
            <NoStock />
            არ არის მარაგში
          </span>
        )}
        {1 === stock_status && (
          <span className="in-stock">
            <Stock />
            მარაგშია
          </span>
        )}
        {3 === stock_status && (
          <span className="in-stock blue-background">
            <Stock color="#ffffff" />
            მარაგშია
          </span>
        )}
        {2 === stock_status && (
          <span className="check-amount-stock">მარაგი გადასამოწმებელია</span>
        )}
      </StorageStatusContainer>
      <DeliveryInfo />
    </ProductService>
  )

  const RightPaneSuggestions = (
    <>
      <Slider
        type="right-product-items"
        productItems={product.related_products || []}
      />
    </>
  )

  return (
    <ProductActions>
      {!inStock ? RightPaneSuggestions : null}

      {isMobile || !inStock ? null : serviceInfo}
      {inStock && <h4 className="buy-title">აირჩიე გადახდის მეთოდი</h4>}
      <BillingAndDelivery sku={product.sku} />
      {isMobile && inStock ? serviceInfo : null}
    </ProductActions>
  )
}

export function BuyProductFooter({ onClick }) {
  const { product, inStock, productPrice } = useProduct()

  const scrollIntoBuyButton = () => {
    if (!window.buyButtonRef || !window.buyButtonRef.current) return

    window.buyButtonRef.current.scrollIntoView()
  }

  return (
    <>
      {inStock ? (
        <FooterProductActions>
          <ProductPrice className="sidebar-price">
            <h2>
              <span className="saled">{productPrice}₾</span>
              {product.old_price && (
                <span className="original">
                  <span>{product.old_price}₾</span>
                </span>
              )}
            </h2>
          </ProductPrice>
          <div className={'buy'} onClick={scrollIntoBuyButton}>
            ყიდვა
          </div>
        </FooterProductActions>
      ) : null}
    </>
  )
}

function BillingAndDelivery(props) {
  let { product, installmentPrice, productPrice } = useProduct()
  const { addToCart, payMethod, setPayMethod, installmentAvialable } = useCart()
  const history = useHistory()
  const [isLoding, setIsLoading] = useState(false)
  const [isCartLoding, setCartIsLoading] = useState(false)
  const {
    product: { sku, price, dels },
    chosenVariants,
    inStock,
  } = useProduct()
  const canInstallment = installmentAvialable || price > 80

  const changePayMethod = e => {
    return setPayMethod(e.target.value)
  }

  const itemAddedToCart = status => {
    let shouldRedirect = status === 'buy'
    shouldRedirect ? setIsLoading(true) : setCartIsLoading(true)

    setTimeout(() => {
      addToCart(sku, chosenVariants, true, shouldRedirect).then(() => {
        onProductAddToCartEvent(product, {
          payMethod: payMethod,
        })
        if (shouldRedirect) {
          history.push('/purchase')
        }
        if (!shouldRedirect) {
          toast.success('დაემატა კალათაში', {
            theme: 'colored',
          })
        }

        setIsLoading(false)
        setCartIsLoading(false)
      })
    }, 300)
  }

  useEffect(() => {
    const installment = canInstallment && dels.installment

    if (payMethod === 'installment' && !installment) {
      if (dels.cash) {
        setPayMethod('cash')
      } else {
        setPayMethod('card')
      }
    } else if (payMethod === 'cash' && !dels.cash) {
      if (installment) {
        setPayMethod('installment')
      } else {
        setPayMethod('card')
      }
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      {inStock && (
        <ProductActionInputs className="flex flex-col gap-y-2">
          <div className="flex">
            <Input
              component="radio"
              name="paymethod"
              value="card"
              title={readablePayMethod('card')}
              checked={payMethod === 'card'}
              onChange={changePayMethod}
              circleType="orange"
            />
            {/* <SpecialTag style={{ marginLeft: '15px' }} type={'sale'}>
              <Percent3 color={'white'} size={'16px'} />
              დაიბრუნე 30%
            </SpecialTag> */}
          </div>
          {canInstallment && dels.installment ? (
            <div className={''}>
              <Input
                component="radio"
                title={readablePayMethod('installment')}
                circleType="orange"
                name="paymethod"
                value="installment"
                checked={payMethod === 'installment'}
                onChange={changePayMethod}
              />
            </div>
          ) : null}
          {dels.cash ? (
            <div className={''}>
              <Input
                component="radio"
                name="paymethod"
                value="cash"
                checked={payMethod === 'cash'}
                title={readablePayMethod('cash')}
                onChange={changePayMethod}
                circleType="orange"
              />
            </div>
          ) : null}
          {dels.bank ? (
            <div className="flex items-center">
              <Input
                component="radio"
                name="paymethod"
                value="bank"
                checked={payMethod === 'bank'}
                title={readablePayMethod('bank')}
                onChange={changePayMethod}
                circleType="orange"
              />
              <SpecialTag style={{ marginLeft: '5px' }} type={'sale'}>
                ფასდაკლება -2%
              </SpecialTag>
            </div>
          ) : null}
        </ProductActionInputs>
      )}

      {inStock ? (
        <ProductPrice className="sidebar-price">
          {installmentPrice && payMethod === 'installment' ? (
            <h3 className={'right-installment'}>
              განვადებით
              <span className={'right-installment-num'}>
                {installmentPrice}₾
              </span>
              თვეში
            </h3>
          ) : (
            <h2>
              <span className="saled">
                <span style={{ fontSize: 16, color: 'black' }}>
                  {payMethod === 'bank' ? 'ფასდაკლებით ' : ''}
                </span>
                {calculateProductPrice(productPrice, {
                  pay_method: payMethod,
                })}
                ₾
              </span>
              {product.old_price ? (
                <span className="original">
                  <span>{product.old_price}₾</span>
                </span>
              ) : null}
            </h2>
          )}
        </ProductPrice>
      ) : null}
      {/* {fastBuy && <ProductPuchaseFormWithoutCart />} */}
      {/* {payMethod === 'card' ? <ProductPurchaseWithCard /> : null} */}
      {inStock ? (
        <div>
          <div className="w-full flex justify-center p-4">
            <Button
              onClick={() => itemAddedToCart('buy')}
              className="w-full "
              color="orange"
              type="submit"
            >
              <div className="flex w-full gap-2 justify-center">
                {isLoding ? (
                  <ReactLoaderSpinner
                    type="ThreeDots"
                    color="#fff"
                    height={30}
                    width={30}
                  />
                ) : (
                  'ყიდვა'
                )}
              </div>
            </Button>
          </div>
          <div
            className="w-full flex justify-center"
            style={{ padding: '0 10px 10px 10px' }}
          >
            <Button
              onClick={() => itemAddedToCart('cart')}
              className="w-full "
              color="lightBlue"
              type="click"
            >
              <div className="flex w-full gap-2 justify-center">
                {isCartLoding ? (
                  <ReactLoaderSpinner
                    type="ThreeDots"
                    color="#fff"
                    height={30}
                    width={30}
                  />
                ) : (
                  'კალათაში დამატება'
                )}
              </div>
            </Button>
          </div>
        </div>
      ) : null}
    </Fragment>
  )
}

function DeliveryInfo() {
  const {
    product: { delivery_price, details, updated_at },
  } = useProduct()

  return (
    <Fragment>
      <DeliveryInfoContainer>
        <Delivery height="23.995px" width="30px" color="#5FB20A" />
        <span>
          <h2>{delivery_price > 0 ? null : 'უფასო'} მიწოდება: 1-4 დღე </h2>
          <p className="where">მთელი საქართველოს მასშტაბით</p>
          {updated_at ? (
            <div>
              <br />
              <h2 className="where">გაახლების თარიღი: {updated_at}</h2>
            </div>
          ) : null}
        </span>
      </DeliveryInfoContainer>
      <MobileView>
        <CardContainer>
          <div className="flex items-center space-x-2">
            <img
              src={'/img/citrus-shop.png'}
              className={'max-w-[45px] h-auto w-full shrink-0'}
              alt={'citrus shop'}
            />
            <p className={'text-sm text-[#5c6772]'}>
              <span className={'!font-extrabold text-black'}>
                ფიზიკური მაღაზიის მისამართი:
              </span>
              <br />
              თბილისი, ალ. ყაზბეგის გამზირი 2ა
            </p>
          </div>
        </CardContainer>
      </MobileView>
      {parseInt(details.warranty) > 0 ? (
        <WarrantyContainer>
          <BorderedSuccess2 />
          <span>
            <p>გარანტია:</p>
            <p className="warranty-length">{details.warranty} თვე</p>
          </span>
        </WarrantyContainer>
      ) : null}
    </Fragment>
  )
}
